import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export type documentsByIdDataType = {
  id: string;
  errorCallback?: Function;
  successCallback?: Function;
  resultKey?: string;
};

export default ({ id, errorCallback, successCallback, resultKey = 'platformDataById' }: documentsByIdDataType) =>
  requestAsync({
    url: endpoints.getPlatformByIdUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getPlatformByIdUrl(id),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
      successCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
